module.exports = __webpack_public_path__ + "assets/img/driver-btn-0e6b87be.png";